import React, { useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { CommonWorkflowService } from '@savgroup-front-common/core/api';
import { Collapse } from '@savgroup-front-common/core/atoms/Collapse';
import { AdditionalInformation } from '@savgroup-front-common/core/components/AdditionalInformationWithReactHookForm';
import { useUploadAttachementsOnClaimGroup } from '@savgroup-front-common/core/hooks/useUploadAttachementsOnClaimGroup';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { useRoutedStepsOrchestratorContext } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.context';
import { AdditionalInformationExtended } from '@/types';

import useGetSellerConfiguration from '../../../app/hooks/useGetSellerConfiguration';
import { InitContext } from '../../../app/NewLayout/InitProvider/InitProvider.context';
import { IrshStepValues } from '../IrshPages.types';

interface ClaimGroupReasonPageAdditionalInformationsContentProps {
  formContext: UseFormReturn<any>;
  neededInformation: AdditionalInformationExtended[];
}

const ClaimGroupReasonPageAdditionalInformationsContent: React.FC<
  ClaimGroupReasonPageAdditionalInformationsContentProps
> = ({ formContext, neededInformation }) => {
  const { orders } = useContext(InitContext);
  const sellerId = orders ? orders[0].sellerId : undefined;

  const { values } = useRoutedStepsOrchestratorContext<IrshStepValues>();
  const claimGroupId = values?.claimGroupId;

  const { handleUploadAttachementOnClaimGroup } =
    useUploadAttachementsOnClaimGroup({
      claimGroupId,
      claimIds: values?.claims?.map((claim) => claim.claimId) ?? [],
    });
  const { sellerConfiguration: seller } = useGetSellerConfiguration({
    sellerId: values.order?.sellerId,
  });

  if (!sellerId) {
    return <BaseLoader />;
  }

  return (
    <Collapse isOpen={Boolean(neededInformation?.length)}>
      <AdditionalInformation
        neededInformation={neededInformation}
        formContext={formContext}
        prefixFormName="reasonAdditionalInformation"
        ignoreUniquenessByProduct
        fullSizeItem
        isScrollIntoView
        isNewDesign
        onNeedToUploadFileAttachements={handleUploadAttachementOnClaimGroup}
        sellerId={sellerId}
        getQrUploadLink={
          CommonWorkflowService.getFileAttachmentUploadLinkFromMyAccountCommand
        }
        currency={seller?.currency}
      />
    </Collapse>
  );
};

export default ClaimGroupReasonPageAdditionalInformationsContent;
